export default __webpack_public_path__ + "static/media/chocolate-bottle.f4447c50.png";